import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import layout from '../styles/layout';
import palette from '../styles/palette';
import { QuantumLogo } from '../icons';

const useStyles = makeStyles(({ typography }) => ({
  header: {
    backgroundColor: palette.dpdRed,
    display: 'flex',
    height: typography.pxToRem(layout.header.height),
  },
}));

const Header = ({ children }) => {
  const classes = useStyles();
  return (
    <Box className={classes.header}>
      <QuantumLogo />
      <Box
        flexGrow={1}
        justifyContent="flex-end"
        display="flex"
        alignItems="center"
      >
        {children && { ...children }}
      </Box>
    </Box>
  );
};

export default Header;
